import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

export type ThemeMode = 'light' | 'dark' | 'auto';

export type ThemeModeOption = {
  id: ThemeMode;
  labelKey: string;
  hintKey: string;
};

export const THEME_MODE_OPTIONS: ThemeModeOption[] = [
  {
    id: 'light',
    labelKey: 'LIGHT_THEME',
    hintKey: 'ONBOARDING_THEME_MODE_LIGHT_HINT',
  },
  {
    id: 'dark',
    labelKey: 'DARK_THEME',
    hintKey: 'ONBOARDING_THEME_MODE_DARK_HINT',
  },
  {
    id: 'auto',
    labelKey: 'AUTO_THEME',
    hintKey: 'ONBOARDING_THEME_MODE_AUTO_HINT',
  },
];

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

  constructor() {}

  getSavedMode(): ThemeMode {
    const saved = localStorage.getItem('theme');
    if (saved === 'dark' || saved === 'light' || saved === 'auto') {
      return saved;
    }
    return 'auto';
  }

  initFromStorage(): void {
    this.chooseTheme(this.getSavedMode());
  }

  private applyStatusBar(style: Style, backgroundColor: string): void {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    void StatusBar.setStyle({ style });
    void StatusBar.setBackgroundColor({ color: backgroundColor });
  }

  handleThemeChange = (mediaQuery) => {
    document.body.classList.toggle('dark', mediaQuery.matches);

    console.log('mediaQuery.matches: ', mediaQuery.matches);
    this.applyStatusBar(
      mediaQuery.matches ? Style.Dark : Style.Light,
      this.prefersDark.matches ? '#262626' : '#ffffff'
    );
  };

  chooseTheme(mode: ThemeMode | string | null): void {
    if (mode === 'dark') {
      this.prefersDark.removeEventListener('change', this.handleThemeChange);
      localStorage.removeItem('theme');
      localStorage.setItem('theme', 'dark');
      document.body.classList.toggle('dark', true);
      this.applyStatusBar(Style.Dark, '#000000');
    } else if (mode === 'light') {
      this.prefersDark.removeEventListener('change', this.handleThemeChange);
      localStorage.removeItem('theme');
      localStorage.setItem('theme', 'light');
      document.body.classList.toggle('dark', false);
      this.applyStatusBar(Style.Light, '#ffffff');
    } else if (mode === 'auto' || mode === null) {
      localStorage.removeItem('theme');
      localStorage.setItem('theme', 'auto');

      document.body.classList.toggle('dark', this.prefersDark.matches);

      this.applyStatusBar(
        this.prefersDark.matches ? Style.Dark : Style.Light,
        this.prefersDark.matches ? '#262626' : '#ffffff'
      );

      this.prefersDark.removeEventListener('change', this.handleThemeChange);
      this.prefersDark.addEventListener('change', this.handleThemeChange);
    }
  }
}
